let initialState = {
    formData: {},
    isDefault: true,
    isNotified: false
};

const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD-FORM-DATA':
            state = {
                ...state,
                formData: {
                    ...state.formData,
                    ...action.payload
                }
            };
            break;
        case 'UPDATE-DEFAULT-FLAG':
            state = {
                ...state,
                isDefault: action.payload                
            };
            break;
        case 'CLEAR-FORM-DATA':
            state = {
                ...initialState
            };
            break;
        default:
            return state;
    };

    return state;
};

export default formReducer;